import AXIOS from '@/services/axios-wrapper';
import moment from 'moment';
import {programInfo, ResProgramInfo, ResProgramList} from '@/pages/PleisureReservePage/Model/reserve.model';
import boardService from '@/services/board.service';
import {BoardArticle, PMSResDto} from '@/models';

import hotelType from './hotelType';
import {BOARD_ID_PKG, BOARD_ID_ROOM} from '@/pages/PleisureReservePage/API/hotelBoardID';

class ReservationService {
  constructor() {
    console.log('creating new instance of ReservationService');
  }

  // Pleisure 예약 API

  async getProgramList(): Promise<ResProgramList> {
    const emptyData = {};
    const reqResult = await AXIOS.post<ResProgramList>('/pleisure/ProgramList', emptyData);
    return reqResult.data;
  }
  async getPrograminfo(programCode: string): Promise<ResProgramInfo> {
    const data = {programCode: programCode};
    const reqResult = await AXIOS.post<ResProgramInfo>('/pleisure/ProgramInfo', data);
    return reqResult.data;
  }
  async ReservNew(data: any): Promise<any> {
    const reqResult = await AXIOS.post<any>('/pleisure/ReservNew', data);
    return reqResult.data;
  }
}

// Export a singleton instance in the global namespace
const reserveService = new ReservationService();

export default reserveService;
